import { render, staticRenderFns } from "./AccountHealthCard.vue?vue&type=template&id=540ac34e&"
import script from "./AccountHealthCard.vue?vue&type=script&lang=js&"
export * from "./AccountHealthCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports